import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../../../../common/ConfirmDialog';

interface PageClosingDialogProps {
  open: boolean;
  content: React.ReactNode;
  onClose: () => void;
  onContinue: () => void;
  amount?: number;
  equipmentName?: string;
}

const DeleteDialog = (props: PageClosingDialogProps) => {
  const { t } = useTranslation();

  const onConfirmDeleteReservation = () => {
    props.onContinue();
    props.onClose();
  };

  return (
    <ConfirmDialog
      open={props.open}
      title={t('book_location.confirmation.delete_reservation_title', {
        amount: props.amount,
        equipment: props.equipmentName,
      })}
      content={props.content}
      cancelText={t('book_location.confirmation.delete_reservation_cancel')}
      confirmText={t('book_location.confirmation.delete_reservation_confirm')}
      onClose={props.onClose}
      onConfirm={onConfirmDeleteReservation}
    />
  );
};

export default DeleteDialog;
